import {
    GET_ALL_INVOICES, GET_DUE_AMOUNTS, SET_INVOICE_PAYMENT_MEDIUM, UPDATE_STATUS_FORFINANCE, INSERT_BUDGET_AMOUNT,
    GET_BUDGET_AMOUNT, UPDATE_PRIORITY, GET_ALL_INVOICES_FOR_SPECIAL_CASE, UPDATE_COMMENT_IN_INVOICE,
    GET_ALL_INVOICES_WHERE_PAYEMENT_RECEIVED, UPDATE_PAYABLE_AMOUNT_IN_INVOICE, POST_SPLIT_BUDGET, GET_SPLIT_BUDGET,
    GET_ALL_INVOICES_FOR_SUPLLIER, POST_INVOICE_DETAILS, GET_INVOICE_DETAILS_FOR_AP_TEAM_APPROVAL,
} from '../type'

const initialState = {
    loading: true,
    allInvoices: [],
    allInvoicesSpl: [],
    dueAmounts: [],
    paymentmedium: [],
    budgetamount: [],
    paymentReceived: [],
    getsplitAmountData: [],
    splitAmountData: [],
    getAllInvoicesforSupplier: [],
    getAllInvoicesforApTeamApproval: [],
}

export default function invoiceReducer(state = initialState, action) {
    switch (action.type) {

        case GET_ALL_INVOICES:
            return {
                ...state,
                allInvoices: action.payload,
                loading: false
            }

        case GET_DUE_AMOUNTS:
            return {
                ...state,
                dueAmounts: action.payload,
                loading: false
            }

        case SET_INVOICE_PAYMENT_MEDIUM:
            return {
                ...state,
                paymentmedium: action.payload,
                loading: false
            }

        case UPDATE_STATUS_FORFINANCE:
            return {
                ...state,
                loading: false
            }

        case INSERT_BUDGET_AMOUNT:
            return {
                ...state,
                loading: false
            }

        case GET_BUDGET_AMOUNT:
            return {
                ...state,
                budgetamount: action.payload,
                loading: false
            }

        case UPDATE_PRIORITY:
            return {
                ...state,
                loading: false
            }

        case GET_ALL_INVOICES_FOR_SPECIAL_CASE:
            return {
                ...state,
                allInvoicesSpl: action.payload,
                loading: false
            }

        case GET_ALL_INVOICES_WHERE_PAYEMENT_RECEIVED:
            return {
                ...state,
                paymentReceived: action.payload,
                loading: false
            }

        case UPDATE_COMMENT_IN_INVOICE:
            return {
                ...state,
                loading: false
            }

        case UPDATE_PAYABLE_AMOUNT_IN_INVOICE:
            return {
                ...state,
                loading: false
            }
        case POST_SPLIT_BUDGET:
            return {
                ...state,
                splitAmountData: action.payload,
                loading: false
            }
        case GET_SPLIT_BUDGET:
            return {
                ...state,
                getsplitAmountData: action.payload,
                loading: false
            }
        case GET_ALL_INVOICES_FOR_SUPLLIER:
            return {
                ...state,
                getAllInvoicesforSupplier: action.payload,
                loading: false
            }
        case POST_INVOICE_DETAILS:
            return {
                ...state,
                loading: false
            }
        case GET_INVOICE_DETAILS_FOR_AP_TEAM_APPROVAL:
            return {
                ...state,
                getAllInvoicesforApTeamApproval: action.payload,
                loading: false
            }

        default: return state
    }
}